import http from "@/settings/apiSettings";

class BugReportService {
  add(data: any): Promise<any> {
    return http.clientAuth.post("/BugReport/Add", data);
  }
  getAll(): Promise<any> {
    return http.clientAuth.get("/BugReport/GetAll");
  }
  getById(id: string): Promise<any> {
    return http.clientAuth.get(`/BugReport/${id}`);
  }
  getScreenshot(id: string): Promise<any> {
    return http.clientAuth.get(`/BugReport/${id}/screenshot`, { responseType: 'blob' });
  }
  updateStare(id: string, stare: string): Promise<any> {
    return http.clientAuth.patch(`/BugReport/${id}/Stare`, { Stare: stare });
  }
}

export default new BugReportService();
